import { createClient } from "@connectrpc/connect";
import { createConnectTransport } from "@connectrpc/connect-web";

import { AuthService } from "../gen";
import { setAuthTokens } from "../shared/lib/authSession";
import { apiBaseUrl } from "./apiBaseUrl";

/**
 * Bare transport for `AuthService.RefreshToken`.
 *
 * The refresh token in the request body is the credential, so no auth header is
 * needed — and no interceptors either: going through the app transport would put
 * refresh behind the refresh interceptor, leaving a failing refresh to refresh
 * itself.
 */
const refreshTransport = createConnectTransport({
  baseUrl: apiBaseUrl,
  useBinaryFormat: false,
});

const refreshClient = createClient(AuthService, refreshTransport);

/**
 * Exchanges the refresh token for a new access token and persists both.
 *
 * The response also carries `me`; it is ignored here because the stored user is
 * fed by `Me`, which RTK Query refetches on its own.
 */
export async function refreshAccessToken(refreshToken: string): Promise<string | null> {
  const response = await refreshClient.refreshToken({ refreshToken });
  if (!response.accessToken) return null;

  setAuthTokens({
    accessToken: response.accessToken,
    tokenType: response.tokenType,
    refreshToken: response.refreshToken,
  });
  console.warn("[Transport:Refresh] Access token refreshed");

  return response.accessToken;
}
